import type { ISocialOffer } from "@bbj-types/offer";
import type { IDateRange } from "@inputs/date/DateRangePicker";
import { useAddSocialOfferSpotlight } from "@root/api/services/offers/socialOffer/addSpotlightSocialOffer";
import { useGlobalContext } from "@root/context";
import { useMemo, useState } from "react";
import type { IDrawerSocialOfferHeaderProps } from "..";

export const useConfirmAddSocialOfferSpotlight = <T extends ISocialOffer>(
  offer: T,
  onClose: () => void,
  onUpdateOffer: IDrawerSocialOfferHeaderProps<T>["onUpdateOffer"]
) => {
  const { user } = useGlobalContext();
  const [rangeSpotlight, setRangeSpotlight] = useState<IDateRange>();
  const [errorRange, setErrorRange] = useState(false);
  const [{ loading }, addSocialOfferSpotlight] = useAddSocialOfferSpotlight();

  const handleClickAddSpotilght = async () => {
    if (rangeSpotlight?.startDate && rangeSpotlight?.endDate) {
      try {
        const res = await addSocialOfferSpotlight(offer.offerId, {
          dates: rangeSpotlight,
          ...(user.organisation.features.team.active
            ? { teams: user.organisation.teams?.map((team) => team._id) }
            : undefined),
        });

        window.publish("feedback", {
          severity: "success",
          message: "L'offre a bien été mise à la une sur la période choisie.",
        });
        onUpdateOffer?.({ ...offer, spotlightDates: rangeSpotlight, spotlightId: res.data });
        onClose();
      } catch (e) {
        window.publish("feedback", {
          severity: "error",
          message: "Une erreur est survenue lors de la mise à la une de l'offre.",
        });
      }
    } else {
      setErrorRange(true);
    }
  };

  const rangeError = useMemo(() => {
    if (
      offer.serviceEndDate &&
      offer.serviceStartDate &&
      rangeSpotlight?.endDate &&
      offer.serviceEndDate.getTime() < rangeSpotlight.endDate.getTime()
    ) {
      return true;
    }
    setErrorRange(false);
    return false;
  }, [rangeSpotlight, offer.serviceEndDate, offer.serviceStartDate]);
  return { handleClickAddSpotilght, rangeSpotlight, setRangeSpotlight, loading, rangeError, errorRange };
};
